import { combineReducers } from 'redux';
import * as appReducers from './appReducers';
import * as apiReducers from './apiReducers';
import http from './httpReducers';
import loading from './loadingReducer';
import teamlocks from './locksReducer';

const reducers = {
  app: combineReducers(appReducers),
  api: combineReducers(apiReducers),
  http,
  loading,
  teamlocks,
};

export default reducers;
